export * from './VideoWrapper';
import { QUANTUM_UI } from '../../../flags';
import { VideoWrapper as VideoWrapperNew } from './VideoWrapper';
import { VideoWrapper as VideoWrapperOld } from './VideoWrapper.old';
export var VideoWrapper = QUANTUM_UI ? VideoWrapperNew : VideoWrapperOld;
